module.exports = __webpack_public_path__ + "static/img/5.1013c8d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/eng/5.png
// module id = 3t9W
// module chunks = 0